module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_13.a7ac57cf.png";